// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PaimemoravelV2RouteImport } from './routes/paimemoravel-v2'
import { Route as PaimemoravelRouteImport } from './routes/paimemoravel'
import { Route as IndexRouteImport } from './routes/index'

const PaimemoravelV2Route = PaimemoravelV2RouteImport.update({
            id: '/paimemoravel-v2',path: '/paimemoravel-v2',getParentRoute: () => rootRouteImport
          })
const PaimemoravelRoute = PaimemoravelRouteImport.update({
            id: '/paimemoravel',path: '/paimemoravel',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,PaimemoravelRoute: PaimemoravelRoute,PaimemoravelV2Route: PaimemoravelV2Route
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)